{
  "navigation": {
    "dashboard": "Dashboard"
  },
  "user": {
    "notifications": "Notifications"
  }
}
